export default __webpack_public_path__ + "static/media/options.64caab04.png";